import React, { useState } from "react";
import { Box, Button, Grid2, Typography } from "@mui/material";
import axios from "axios";

const Step3 = ({ tender, setTender, user, setStep }) => {
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);

  const handleChange = (e) => {
    setTender({ ...tender, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = tender || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.emdBank)) newErrors.emdBank = "Advisory Bank is required";
    if (isEmpty(data.emdAmount)){
      newErrors.emdAmount = "EMD Amount is required";
    } else if (data.emdAmount <= 0){
      newErrors.emdAmount = "EMD Amount is should be greater than 0";
    }
    if (isEmpty(data.accountNumber))
      newErrors.accountNumber = "Bank Account Number is required";
    if (isEmpty(data.ifsc)) {
      newErrors.ifsc = "IFSC code is required";
    } else {
      const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      if (!ifscRegex.test(data.ifsc)) {
        newErrors.ifsc = "Enter a valid IFSC code (e.g., SBIN0001234)";
      }
    }
    if (isEmpty(data.accountName))
      newErrors.accountName = "Beneficiary Name is required";
    if (isEmpty(data.accountType))
      newErrors.accountType = "Account Type is required";
    if (isEmpty(data.pbgBank)) newErrors.pbgBank = "Advisory Bank is required";
    if (isEmpty(data.pbgPercentage)) {
      newErrors.pbgPercentage = "ePBG Percentage is required";
    } else if (data.pbgPercentage <= 0 || data.pbgPercentage >= 100){
      newErrors.pbgPercentage = "ePBG Percentage should be in between 0 to 100%";
    }
    if (isEmpty(data.pbgDuration))
      newErrors.pbgDuration = "ePBG Duration is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft?draftTenderId=${tender.draftTenderId}`,
        {
          emdBank: tender.emdBank,
          emdAmount: tender.emdAmount,
          accountNumber: tender.accountNumber,
          ifsc: tender.ifsc,
          accountName: tender.accountName,
          accountType: tender.accountType,
          pbgBank: tender.pbgBank,
          pbgPercentage: tender.pbgPercentage,
          pbgDuration: tender.pbgDuration,
        },
        { headers: { Authorization: `Bearer ${user.accessToken}` } }
      );
      setTender(res.data);
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    setStep((prev) => prev - 1);
  };
  return (
    <div style={{position: 'relative'}}>
      {btnLoading && (
        <div className="loading-div"></div>
      )}
      <h2>Create New Tender</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "50%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">EMD Details</Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="emdBank">Advisory Bank</label>
            <input
              type="text"
              id="emdBank"
              name="emdBank"
              className={`${errors.emdBank && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.emdBank}
            />
            {errors.emdBank && <p className="error">{errors.emdBank}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="emdAmount">EMD Amount (in &#8377;)</label>
            <input
              type="number"
              name="emdAmount"
              id="emdAmount"
              className={`${errors.emdAmount && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.emdAmount}
              onKeyDown={(e) => {
                if ([".", ",", "e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
            {errors.emdAmount && <p className="error">{errors.emdAmount}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="accountNumber">Bank Account Number</label>
            <input
              type="text"
              id="accountNumber"
              name="accountNumber"
              className={`${errors.accountNumber && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.accountNumber}
            />
            {errors.accountNumber && (
              <p className="error">{errors.accountNumber}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="ifsc">IFSC</label>
            <input
              type="text"
              id="ifsc"
              name="ifsc"
              className={`${errors.ifsc && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.ifsc}
            />
            {errors.ifsc && <p className="error">{errors.ifsc}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="accountName">Beneficiary Name</label>
            <input
              type="text"
              id="accountName"
              name="accountName"
              className={`${errors.accountName && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.accountName}
            />
            {errors.accountName && (
              <p className="error">{errors.accountName}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="accountType">Account Type</label>
            <input
              type="text"
              id="accountType"
              name="accountType"
              className={`${errors.accountType && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.accountType}
            />
            {errors.accountType && (
              <p className="error">{errors.accountType}</p>
            )}
          </Grid2>
        </Grid2>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">ePBG Details</Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="pbgBank">Advisory Bank</label>
            <input
              type="text"
              id="pbgBank"
              name="pbgBank"
              className={`${errors.pbgBank && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.pbgBank}
            />
            {errors.pbgBank && <p className="error">{errors.pbgBank}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="emdAmount">ePBG Percentage (in %)</label>
            <input
              type="number"
              name="pbgPercentage"
              id="pbgPercentage"
              className={`${errors.pbgPercentage && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.pbgPercentage}
            />
            {errors.pbgPercentage && (
              <p className="error">{errors.pbgPercentage}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="pbgDuration">
              Duration of ePBG required (Months)
            </label>
            <input
              type="text"
              id="pbgDuration"
              name="pbgDuration"
              className={`${errors.pbgDuration && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.pbgDuration}
            />
            {errors.pbgDuration && (
              <p className="error">{errors.pbgDuration}</p>
            )}
          </Grid2>
        </Grid2>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step3;
